(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("GraphQLVoyager", [], factory);
	else if(typeof exports === 'object')
		exports["GraphQLVoyager"] = factory();
	else
		root["GraphQLVoyager"] = factory();
})(self, () => {
return 